<script lang="ts">
	import type { Insert } from "$lib/def/seo/insert";
	import { getCimgUrl } from "$lib/serv/admin/editImg";
	import { qrcode } from "$lib/serv/admin/editLink";
	import { imgSrc } from "$lib/serv/image-details";
	import { geoOpted$, setGeoOpted } from "$lib/serv/locations";
	import { selectAddress } from "$lib/ui/modals/AddressModal.svelte";

	export let main: Insert;
	export let appstores: [string?, string?][];
	export let type: 'plain' | 'generic' = 'generic';
	export let customTitle: string | null = null;

	async function currentLocation() {
		setGeoOpted();
		selectAddress();
	}

</script>

<section class="app-download {type}">
	{#if type !== 'plain'}
	<div>
		<img src={getCimgUrl(main.image)} alt="download the Mr D app">
	</div>
	{/if}
	<article>
		<h3 class="display-m">{customTitle ?? main.title}</h3>
		<div class="qrs">
			{#each appstores as [img,url]}
				<a href={url} target="_blank">
					<img src={imgSrc(img)} alt="App store">
					{#if url}
						<canvas use:qrcode={[url]}></canvas>
					{/if}
				</a>
			{/each}
		</div>
		{#if type !== 'plain'}
		<div class="buttons">
			<button class="button primary" on:click={() => selectAddress()}><span class="icon-pin-outline-20"></span> Enter address</button>
			{#if !$geoOpted$}
				<button class="button secondary" on:click={(e) => currentLocation()}><span class="icon-current-location-20"></span> Use current location</button>
			{/if}
		</div>
		{/if}
	</article>
</section>

<style lang="scss">
	@use 'color';
	@use 'screen';

	// dark mode
	// :global(.dark) .darkMode {
	// 	filter: invert(100%);
	// }

	.app-download {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 6rem 0;
		@media(min-width: 820px) {
			flex-direction: row;
			align-items: flex-start;
			justify-content: center;
			margin: 5rem 0;
		}
		@media(screen.$md) { margin: 7.5rem 0; }
		@media(screen.$mdl) { margin: 10rem 0; }
		>div {
			position: relative;
			width: 320px;
			aspect-ratio: 1/1;
			background: color.$separator;
			border-radius: 30px;
			overflow: hidden;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
			border: 1px solid color.$separator;
			@media(screen.$xs) { width: 350px; min-width: 350px; }
			@media(screen.$lg) { width: 380px; }
			>img {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		article {
			text-align: center;
			@media(min-width: 820px) {
				text-align: left;
				padding-left: 2rem;
			}
			@media(screen.$md) { padding-left: 3rem; }
			@media(screen.$md) { padding-left: 5rem; }
			h3 { 
				margin: 1rem 0;
				@media(min-width: 820px) {
					margin: 0 0 1rem 0;
					text-align: left;
					max-width: 400px;
				}
			}
			.qrs {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin: 1.5rem 0;
				@media(min-width: 820px) {
					flex-direction: row;
					justify-content: flex-start;
				}
				a {
					display: flex;
					flex-direction: column;
					align-items: center;
					border: 2px solid color.$separator;
					border-radius: 14px;
					background: color.$white;
					margin: 0 0 1rem 0;
					padding: .6rem;
					width: 150px;
					height: 56px;
					overflow: hidden;
					@media(min-width: 820px) {
						margin: 0 .5rem 0 0;
						&:last-child { margin-right: unset; }
					}
					@media(min-width: 890px) {
						height: unset;
					}
					@media(screen.$md) {
						margin: 0 2rem 0 0;
					}
					img, canvas {
						&:nth-child(1) {
							width: inherit;
							height: 40px;
						}
						&:nth-child(2) {
							display: none;
							width: 80px;
							aspect-ratio: 1/1;
							margin: 0.4rem 0 0 0;
							border-radius: 12px;
							@media(min-width: 890px) {
								display: block;
							}
						}
					}
				}
			}
			.buttons {
				display: inline-flex;
				flex-direction: column;
				@media(min-width: 820px) {
					flex-direction: row;
					display: block;
				}
				.primary {
					margin-bottom: 1rem;
					@media(min-width: 820px) {
						margin-right: .5rem;
					}
				}
				button {
					span { margin-right: 8px; }
				}
			}
		}
		&.plain {
			margin: 2rem 0;
			article {
				padding-left: 0;
				display: flex;
				flex-direction: column;
				align-items: center;
				h3 { max-width: 750px; text-align: center; }
			}
		}
	}
</style>